import { useTheme } from '@pata-app/themes';
import { Icon } from '@pata-app/ui-icons';

import React, { Fragment } from 'react';
import styled from 'styled-components';

const ORDERED_REVIEW_SCORES = [5, 4, 3, 2, 1];

interface ReviewScoreProps {
  rating: number;
}

const ScoreRatingContainer = styled.div`
  display: flex;
  gap: 4px;
`;

export default function ReviewScore({ rating }: ReviewScoreProps) {
  return (
    <ScoreRatingContainer>
      {ORDERED_REVIEW_SCORES.map((orderedRating, index) => {
        const theme = useTheme();
        return (
          <Fragment key={orderedRating}>
            <Icon
              type="Star"
              fill={
                index < Math.round(rating)
                  ? theme.core.colors.secondary.yellow.medium
                  : theme.core.colors.greyscale.medium
              }
              size="24px"
            />
          </Fragment>
        );
      })}
    </ScoreRatingContainer>
  );
}
